import { memo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslate } from "../../../context/TranslationContext";
import { useUpdateUserMutation } from "../../../redux/Apis/User";
import SwitchToBothRoleModal from "../../modal/SwitchToBothRoleModal";

const KeyFeatureCard = (props) => {
  const { image, title, text, navigateTo, role } = props;
  const { t } = useTranslate("keyFeaturesSection");
  const lang = useSelector((state) => state.language.lang);
  const { user } = useSelector((state) => state.authSlice);
  const navigate = useNavigate();
  const [showRoleSwitchModal, setShowRoleSwitchModal] = useState(false);
  const [updateUser, { isLoading: isLoadingUpdate }] = useUpdateUserMutation();

  const handleClick = () => {
    if (!navigateTo) return;

    if (!user?.role) {
      toast.info(t("loginRequired"));
      return;
    }

    const needsRoleSwitch =
      (user?.role === "learner" || user?.role === "creator") &&
      (role === "learner" || role === "creator") &&
      user?.role !== role;

    if (needsRoleSwitch) {
      setShowRoleSwitchModal(true);
      return;
    }

    navigate(navigateTo);
  };

  const handleSwitchRole = async () => {
    try {
      const payload = { role: "both" };

      await updateUser({
        id: user?._id,
        payload,
        params: { lang },
      }).unwrap();

      toast.success(
        t(
          user?.role === "learner"
            ? "learnerRoleUpdateSuccess"
            : "creatorRoleUpdateSuccess",
        ),
      );
      setShowRoleSwitchModal(false);
      navigate(navigateTo);
    } catch (err) {
      toast.error(err?.data?.message || t("roleUpdateError"));
    }
  };

  return (
    <>
      <div
        className="key-feature-card"
        onClick={handleClick}
        style={{ cursor: navigateTo ? "pointer" : "default" }}
      >
        <img
          src={image}
          alt=""
          className="img-fluid"
          style={{ width: "65px", objectFit: "contain" }}
        />
        <div className="key-feature-inner mt-3">
          <h6 className="text-uppercase">{title}</h6>
          <p className="l-grey-text mb-0">{text}</p>
        </div>
      </div>

      <SwitchToBothRoleModal
        show={showRoleSwitchModal}
        close={() => setShowRoleSwitchModal(false)}
        onConfirm={handleSwitchRole}
        isLoading={isLoadingUpdate}
        title={
          user?.role === "learner"
            ? t("switchRoleModal.learnerTitle")
            : t("switchRoleModal.creatorTitle")
        }
        subtitle={
          user?.role === "learner"
            ? t("switchRoleModal.learnerSubtitle")
            : t("switchRoleModal.creatorSubtitle")
        }
        paragraph1={
          user?.role === "learner"
            ? t("switchRoleModal.learnerParagraph1")
            : t("switchRoleModal.creatorParagraph1")
        }
        paragraph2={
          user?.role === "learner"
            ? t("switchRoleModal.paragraph2")
            : t("switchRoleModal.paragraph2")
        }
        roleText={
          user?.role === "learner"
            ? t("switchRoleModal.learnerRole")
            : t("switchRoleModal.creatorRole")
        }
        yesText={
          user?.role === "learner"
            ? t("switchRoleModal.LearnerYesBtn")
            : t("switchRoleModal.creatorYesBtn")
        }
        cancelText={t("switchRoleModal.cancelBtn")}
      />
    </>
  );
};

export default memo(KeyFeatureCard);
